export const resultsFiltersReducerKey = 'ResultsFilters';

export const setOpenFiltersType = 'SET_OPEN_FILTERS_TYPE';

export const ascending = 'ascending';
export const descending = 'descending';
export const occurrence = 'occurrence';
export const byValue = 'byValue';
export const preferredSuppliersFilterId = 'SUPP.PREF_SNAME';
export const commercialSuppliersFilterId = 'SUPP.SNAME';
export const shipmentTimeFilterId = 'PROD.SHIPTIME';
export const shippingTimeFilterId = 'PROD.TIER';

export const DOCUMENT_PROCESSING_TYPES = {
  automatic: {
    label: 'Automated',
    icon: 'automated-icon',
  },
  manual: {
    label: 'Manual',
    icon: 'manual-icon',
  },
  getType: (value) => {
    if (!value) {
      return null;
    }
    const key = Object.keys(DOCUMENT_PROCESSING_TYPES).find((type) => value.indexOf(type) >= 0);
    return key ? DOCUMENT_PROCESSING_TYPES[key] : null;
  },
};

/**
 * Additional custom filter by filter ID config if needed. Can override filter value title, additional icon and filter header tooltip
 * @type {{'filterId': {optionIcon: (function(*=): *), tooltip: string, optionTitle: (function(*=): *)}}}
 */
export const filtersCustomConfigMap = {};

export const AUTHOR_NAME_FILTER_ID = 'CIT.AU';
// TODO update with new filters ids when ready
export const AUTHORS_OF_SCI_DOC_FILTER_ID = 'AUTHOR.NAME';
export const AFFILIATIONS_FILTER_ID = 'AUTHOR.AFFILPDISPNAME';
export const INVENTORS_OF_PATENTS_FILTER_ID = 'PBIB.INV';
